import { render } from "./CustomerData.vue?vue&type=template&id=10e689d4&scoped=true&ts=true"
import script from "./CustomerData.vue?vue&type=script&lang=ts"
export * from "./CustomerData.vue?vue&type=script&lang=ts"

import "./CustomerData.vue?vue&type=style&index=0&id=10e689d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e689d4"]])

export default __exports__